export const formatMoney = (cents, currency = "USD", locale = "en-US") =>
  new Intl.NumberFormat(locale, { style: "currency", currency }).format(cents / 100);

export const calculateCartTotal = (cartItems, products) =>
  cartItems.reduce((total, item) => {
    const product = products.find((candidate) => candidate.id === item.id);
    const version = product?.versions.find((candidate) => candidate.id === item.version);
    return total + (version?.price ?? 0);
  }, 0);

export const addUniqueLicense = (cartItems, productId, version = "full") => {
  const exists = cartItems.some((item) => item.id === productId && item.version === version);
  return exists ? cartItems : [...cartItems, { id: productId, version, quantity: 1 }];
};

export const licenseKey = (id, version = "full") => `${id}:${version}`;

export const makeOrderNumber = () => {
  const randomDigits = Array.from({ length: 14 }, () =>
    Math.floor(Math.random() * 10)
  ).join("");
  return `${Date.now()}${randomDigits}`;
};

export const buildPaymentUrl = ({
  origin,
  orderNo,
  amount,
  currency,
  email,
  title,
}) => {
  const paymentUrl = new URL("/create_payment.php", origin);
  paymentUrl.search = new URLSearchParams({
    orderNo,
    amount: (amount / 100).toFixed(2),
    currency,
    email,
    success_url: `${origin}/payment?state=success`,
    cancel_url: `${origin}/payment?state=cancel`,
    title,
  }).toString();
  return paymentUrl.toString();
};
